import React, { useState, useEffect } from "react";
import { Container, Table, Alert, Button, Form, Modal } from "react-bootstrap";
import ManagerService from "../../services/ManagerService";

const XeKinhDoanhComponent = () => {
  const [vehicleData, setVehicleData] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [currentEdit, setCurrentEdit] = useState(null);

  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const response = await ManagerService.getVehicleActivityRates();
        if (response && response.length > 0) {
          setVehicleData(response.map(({ ty_le_hoat_dong, ...rest }) => rest)); // Loại bỏ cột "tỷ lệ hoạt động"
        } else {
          setVehicleData([]);
        }
      } catch (err) {
        console.error("Error fetching vehicle data:", err);
        setError("Không thể tải dữ liệu xe. Vui lòng thử lại sau.");
      } finally {
        setLoading(false);
      }
    };

    fetchVehicleData();
  }, []);

  const handleEdit = (index) => {
    setCurrentEdit({ ...vehicleData[index], index });
    setShowModal(true);
  };

  const handleDelete = async (bienKiemSoat) => {
    if (window.confirm(`Bạn có chắc chắn muốn xóa xe ${bienKiemSoat}?`)) {
      try {
        await ManagerService.deleteVehicle(bienKiemSoat);
        setVehicleData((prevData) =>
          prevData.filter((item) => item.bien_kiem_soat !== bienKiemSoat)
        );
      } catch (error) {
        console.error("Error deleting vehicle:", error);
        alert("Lỗi khi xóa dữ liệu. Vui lòng thử lại sau.");
      }
    }
  };

  const handleSave = async () => {
    try {
      const updatedData = [...vehicleData];
      updatedData[currentEdit.index] = currentEdit;
      setVehicleData(updatedData);

      // Call API to save the updated data
      await ManagerService.updateVehicle(currentEdit);

      setShowModal(false);
      setCurrentEdit(null);
    } catch (error) {
      console.error("Error updating vehicle:", error);
      alert("Lỗi khi cập nhật dữ liệu. Vui lòng thử lại sau.");
    }
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setCurrentEdit((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <span>Đang tải dữ liệu...</span>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <h2 className="mb-4 text-center text-primary">Danh Sách Xe Kinh Doanh</h2>
      {error && (
        <Alert variant="danger" className="mt-4">
          {error}
        </Alert>
      )}
      {vehicleData.length > 0 ? (
        <>
          <div className="table-responsive">
            <Table bordered hover className="table-striped">
              <thead className="table-primary">
                <tr>
                  <th>STT</th>
                  <th>Biển Kiểm Soát</th>
                  <th>Loại Xe</th>
                  <th>Trọng Tải (Kg)</th>
                  <th>Chi Phí Thuê Xe (₫)</th>
                  <th>Định Mức Nhiên Liệu (Lít)</th>
                  <th>Thời Gian Thuê</th>
                  <th>Hành Động</th>
                </tr>
              </thead>
              <tbody>
                {(showAll ? vehicleData : vehicleData.slice(0, 5)).map(
                  (vehicle, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{vehicle.bien_kiem_soat}</td>
                      <td>{vehicle.loai_xe}</td>
                      <td>{vehicle.trong_tai.toLocaleString()}</td>
                      <td>{Number(vehicle.cp_thue_xe).toLocaleString("vi-VN")}</td>
                      <td>{vehicle.dinh_muc_nhien_lieu}</td>
                      <td>{new Date(vehicle.thoi_gian_thue).toLocaleDateString("vi-VN")}</td>
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEdit(index)}
                        >
                          Sửa
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDelete(vehicle.bien_kiem_soat)}
                        >
                          Xóa
                        </Button>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </Table>
          </div>
          <div className="text-center mt-3">
            <Button
              variant="primary"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Ẩn bớt" : "Hiển thị tất cả"}
            </Button>
          </div>
        </>
      ) : (
        <Alert variant="warning" className="text-center">
          Không có dữ liệu để hiển thị.
        </Alert>
      )}

      {/* Modal để chỉnh sửa dữ liệu */}
      {showModal && currentEdit && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh Sửa Xe</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="bien_kiem_soat" className="mb-3">
                <Form.Label>Biển Kiểm Soát</Form.Label>
                <Form.Control
                  type="text"
                  name="bien_kiem_soat"
                  value={currentEdit.bien_kiem_soat}
                  onChange={handleModalChange}
                  disabled
                />
              </Form.Group>
              <Form.Group controlId="loai_xe" className="mb-3">
                <Form.Label>Loại Xe</Form.Label>
                <Form.Control
                  type="text"
                  name="loai_xe"
                  value={currentEdit.loai_xe}
                  onChange={handleModalChange}
                />
              </Form.Group>
              <Form.Group controlId="trong_tai" className="mb-3">
                <Form.Label>Trọng Tải (Kg)</Form.Label>
                <Form.Control
                  type="number"
                  name="trong_tai"
                  value={currentEdit.trong_tai}
                  onChange={handleModalChange}
                />
              </Form.Group>
              <Form.Group controlId="cp_thue_xe" className="mb-3">
                <Form.Label>Chi Phí Thuê Xe (₫)</Form.Label>
                <Form.Control
                  type="number"
                  name="cp_thue_xe"
                  value={currentEdit.cp_thue_xe}
                  onChange={handleModalChange}
                />
              </Form.Group>
              <Form.Group controlId="dinh_muc_nhien_lieu" className="mb-3">
                <Form.Label>Định Mức Nhiên Liệu (Lít)</Form.Label>
                <Form.Control
                  type="number"
                  name="dinh_muc_nhien_lieu"
                  value={currentEdit.dinh_muc_nhien_lieu}
                  onChange={handleModalChange}
                />
              </Form.Group>
              <Form.Group controlId="thoi_gian_thue" className="mb-3">
                <Form.Label>Thời Gian Thuê</Form.Label>
                <Form.Control
                  type="date"
                  name="thoi_gian_thue"
                  value={currentEdit.thoi_gian_thue}
                  onChange={handleModalChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Hủy
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default XeKinhDoanhComponent;
